import { render, staticRenderFns } from "./FlagsDropdown.vue?vue&type=template&id=56c0483a&scoped=true&"
import script from "./FlagsDropdown.vue?vue&type=script&lang=js&"
export * from "./FlagsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FlagsDropdown.vue?vue&type=style&index=0&id=56c0483a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0483a",
  null
  
)

export default component.exports